mutation RenameScene($eventId: ID!, $overlayId: ID!, $sceneId: ID!, $name: String!) {
  scene: StreamToolsRenameScene(eventId: $eventId, overlayId: $overlayId, sceneId: $sceneId, name: $name) {
    sceneId
    overlayId
    eventId
    name
    version
    createdAt
    elements {
      elementKind
      elementId
      x
      y
      z
      scale
      visible
      w
      h
    }
  }
}
